import SamplesList from '../../components/FieldsComponents/SamplesList'
import { connect } from 'react-redux'
import { getActiveSamples } from '../../selectors/samples'
import { selectSampleById, filterSamples } from '../../actions/samples'
import { isSampleFormOpen, getFilteredSamples } from '../../selectors/ui'

const mapStateToProps = state => ({
  samples: getActiveSamples(state),
  isSampleFormOpen: isSampleFormOpen(state),
  filteredSamples: getFilteredSamples(state)
})

const mapDispatchToProps = {
  selectSampleById,
  filterSamples
}

export default connect(mapStateToProps, mapDispatchToProps)(SamplesList)
